import { getReportsByCriteria } from '@nemuru-eng/js-api-client';

import { fetchForDataGrid } from '@/utils/fetchForDataGrid';

export function useReportsList() {
  const fetchReportsList = async (query) => {
    const customFilters = query?.filters;
    return fetchForDataGrid(getReportsByCriteria, { ...query, filters: customFilters });
  };

  return {
    fetchReportsList,
  };
}
